import React, { useEffect } from 'react'

import { LntSwitch } from '@app/components/base'

import { SIZE } from '@app/constants'
import { MONITORING_PRODUCT_STATUS } from '@app/api/constants'

import { isSwitchColumns } from './utils'

import type { RegistryCurrentListDataSource } from '@app/pages/RegistryPageInner/types'
import type { UseSwitchColumnsParams } from './types'

export const useSwitchColumns = ({ columns, patchFn }: UseSwitchColumnsParams): void => {
  useEffect(() => {
    columns.forEach(column => {
      const columnKey = column.key as keyof RegistryCurrentListDataSource

      if (isSwitchColumns(columnKey)) {
        column.render = (_, registryListData) => {
          const { id: productId } = registryListData
          const value = registryListData[columnKey]

          return (
            <LntSwitch
              disabled={ registryListData.status === MONITORING_PRODUCT_STATUS.DELETED }
              size={ SIZE.small }
              checked={ value }
              onChange={ value =>
                patchFn({
                  productId,
                  [columnKey]: value
                })
              }
            />
          )
        }
      }
    })
  }, [patchFn])
}
